import { render, staticRenderFns } from "./OutstandingInvoices.vue?vue&type=template&id=c2767030&scoped=true"
import script from "./OutstandingInvoices.vue?vue&type=script&lang=js"
export * from "./OutstandingInvoices.vue?vue&type=script&lang=js"
import style0 from "./OutstandingInvoices.vue?vue&type=style&index=0&id=c2767030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2767030",
  null
  
)

export default component.exports